export const CURRENT_EVENT = "this";
export const CURRENT_AND_FOLLOWING = "this-and-following";
export const ALL_EVENTS = "all";

export const getRecurringEventOptions = (
  eventType: string,
  eventEndTime: Date
) => {
  const label = eventType.toLowerCase();

  return [
    { label: `This ${label}`, value: CURRENT_EVENT },
    ...(eventEndTime > new Date() || eventType !== "Appointment"
      ? [
          {
            label: `This and following ${label}s`,
            value: CURRENT_AND_FOLLOWING
          }
        ]
      : []),
    ...(eventType !== "Appointment"
      ? [{ label: `All ${label}s`, value: ALL_EVENTS }]
      : [])
  ];
};
